exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sensoractive[data-v-5d0d863e]{display:block;background-color:#d61445;width:auto;padding:0 1em}.sensoractiveMain h1[data-v-5d0d863e]{font-size:1.5em;text-align:center;color:var(--white);line-height:1em;padding-top:.2em;-webkit-animation:blinker-data-v-5d0d863e 1s linear infinite;animation:blinker-data-v-5d0d863e 1s linear infinite}@-webkit-keyframes blinker-data-v-5d0d863e{0%{opacity:0}25%{opacity:1}50%{opacity:1}75%{opacity:1}to{opacity:0}}@keyframes blinker-data-v-5d0d863e{0%{opacity:0}25%{opacity:1}50%{opacity:1}75%{opacity:1}to{opacity:0}}", ""]);

// exports
